import "./App.css";

import MainRouter from "./routes/Router";

function App() {
  return (
    <div className="App">
      <MainRouter />
    </div>
  );
}

export default App;
